import * as React from "react"
import { Loader2 } from "lucide-react"

import { Button } from "@/components/ui/button"
import { ConnectBrokerWizardDialogFooter } from "@/views/Dashboard/Profile/connectBroker/ConnectBrokerWizardLayout"
import type { ConnectBrokerWizardFooterAction } from "@/views/Dashboard/Profile/connectBroker/ConnectBrokerWizardLayout"

/** Same Cancel / Back / Continue chrome as Broker Management connect wizard. */
export function DemoWizardFooter(props: {
  onCancel?: () => void
  onBack?: () => void
  onContinue?: () => void
  continueDisabled?: boolean
  continueLabel?: string
  continueLoading?: boolean
  continueLoadingLabel?: string
  showBack?: boolean
  showContinue?: boolean
  cancelLabel?: string
  primaryFooterAction?: ConnectBrokerWizardFooterAction
}): React.ReactElement {
  const {
    onCancel,
    onBack,
    onContinue,
    continueDisabled = false,
    continueLabel = "Continue",
    continueLoading = false,
    continueLoadingLabel,
    showBack = false,
    showContinue = true,
    cancelLabel = "Cancel",
    primaryFooterAction,
  } = props

  if (continueLoading && onContinue) {
    return (
      <div
        className={
          onCancel
            ? "flex w-full flex-wrap items-center justify-between gap-3"
            : "flex w-full flex-wrap items-center justify-end gap-3"
        }
      >
        {onCancel ? (
          <Button
            type="button"
            variant="outline"
            size="sm"
            data-font="primary"
            data-trade-log-action="delete"
            className="h-8 shrink-0 border-destructive/40 px-5 text-[0.75rem] normal-case tracking-normal text-destructive shadow-sm hover:bg-destructive/10 hover:text-destructive"
            onClick={onCancel}
          >
            <span className="truncate normal-case tracking-normal">{cancelLabel}</span>
          </Button>
        ) : null}
        <div className="flex flex-nowrap items-center gap-3">
          {showBack && onBack ? (
            <Button
              type="button"
              variant="outline"
              size="sm"
              data-font="primary"
              className="h-8 shrink-0 px-5 text-[0.75rem] normal-case tracking-normal"
              onClick={onBack}
            >
              <span className="truncate text-gray-500 normal-case tracking-normal">Back</span>
            </Button>
          ) : null}
          <Button
            type="button"
            variant="gradient"
            size="sm"
            data-font="primary"
            className="h-8 shrink-0 px-5 text-[0.75rem] normal-case tracking-normal"
            disabled
          >
            <Loader2 className="size-4 animate-spin" aria-hidden />
            {continueLoadingLabel ?? "Working…"}
          </Button>
        </div>
      </div>
    )
  }

  return (
    <ConnectBrokerWizardDialogFooter
      onCancel={onCancel}
      cancelLabel={cancelLabel}
      onBack={onBack}
      onContinue={onContinue}
      continueDisabled={continueDisabled}
      continueLabel={continueLabel}
      showContinue={showContinue}
      showBack={showBack}
      primaryFooterAction={primaryFooterAction}
    />
  )
}
